import { mount } from './game.js';
function boot() {
  const root = document.getElementById('slotshurra-plinko');
  if (!root || !window.PlinkoBoot) return;
  mount(root, window.PlinkoBoot).catch(e => { root.insertAdjacentHTML('beforeend', `<p class="pk-fatal">Plinko failed to start: ${e.message}</p>`); console.error(e); });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
